/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFactoryShiftPatternDto,
  CreateShiftOverrideDto,
  FactoryCalendarDayDto,
  FactoryShiftOverrideDto,
  FactoryShiftPatternDto,
  FactoryShiftPatternsControllerGetCalendarParams,
  FactoryShiftPatternsControllerListOverridesParams,
  UpdateFactoryShiftPatternDto,
  UpdateShiftOverrideDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Resolves the active shift pattern per day (cycle rotation included) and applies overrides: public holidays drop slots, reduced_hours replaces net hours, overtime adds hours (slot-specific overtime on an off day synthesises a working slot with null times). Returns one entry per day in the range; days with no pattern coverage come back with is_working=false and no slots. Range is inclusive and limited to 400 days.
 * @summary Effective shift calendar for a factory over a date range
 */
export type factoryShiftPatternsControllerGetCalendarResponse200 = {
  data: FactoryCalendarDayDto[]
  status: 200
}

export type factoryShiftPatternsControllerGetCalendarResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerGetCalendarResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerGetCalendarResponseSuccess = (factoryShiftPatternsControllerGetCalendarResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerGetCalendarResponseError = (factoryShiftPatternsControllerGetCalendarResponse400 | factoryShiftPatternsControllerGetCalendarResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerGetCalendarResponse = (factoryShiftPatternsControllerGetCalendarResponseSuccess | factoryShiftPatternsControllerGetCalendarResponseError)

export const getFactoryShiftPatternsControllerGetCalendarUrl = (factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/shift-patterns/calendar?${stringifiedParams}` : `/factories/${factoryId}/shift-patterns/calendar`
}

export const factoryShiftPatternsControllerGetCalendar = async (factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: RequestInit): Promise<factoryShiftPatternsControllerGetCalendarResponse> => {
  
  return customFetch<factoryShiftPatternsControllerGetCalendarResponse>(getFactoryShiftPatternsControllerGetCalendarUrl(factoryId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoryShiftPatternsControllerGetCalendarQueryKey = (factoryId?: string,
    params?: FactoryShiftPatternsControllerGetCalendarParams,) => {
    return [
    `/factories/${factoryId}/shift-patterns/calendar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFactoryShiftPatternsControllerGetCalendarQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerGetCalendarQueryKey(factoryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>> = ({ signal }) => factoryShiftPatternsControllerGetCalendar(factoryId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(factoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerGetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>>
export type FactoryShiftPatternsControllerGetCalendarQueryError = void


export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Effective shift calendar for a factory over a date range
 */

export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Effective shift calendar for a factory over a date range
 */
export const prefetchFactoryShiftPatternsControllerGetCalendarQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoryShiftPatternsControllerGetCalendarSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerGetCalendarQueryKey(factoryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>> = ({ signal }) => factoryShiftPatternsControllerGetCalendar(factoryId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerGetCalendarSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>>
export type FactoryShiftPatternsControllerGetCalendarSuspenseQueryError = void


export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Effective shift calendar for a factory over a date range
 */

export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns all shift patterns for the factory (including archived, flagged via is_archived), newest start_date first, each with its nested slots and occurrences.
 * @summary List shift patterns for a factory
 */
export type factoryShiftPatternsControllerListPatternsResponse200 = {
  data: FactoryShiftPatternDto[]
  status: 200
}

export type factoryShiftPatternsControllerListPatternsResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerListPatternsResponseSuccess = (factoryShiftPatternsControllerListPatternsResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerListPatternsResponseError = (factoryShiftPatternsControllerListPatternsResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerListPatternsResponse = (factoryShiftPatternsControllerListPatternsResponseSuccess | factoryShiftPatternsControllerListPatternsResponseError)

export const getFactoryShiftPatternsControllerListPatternsUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/shift-patterns`
}

export const factoryShiftPatternsControllerListPatterns = async (factoryId: string, options?: RequestInit): Promise<factoryShiftPatternsControllerListPatternsResponse> => {
  
  return customFetch<factoryShiftPatternsControllerListPatternsResponse>(getFactoryShiftPatternsControllerListPatternsUrl(factoryId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoryShiftPatternsControllerListPatternsQueryKey = (factoryId?: string,) => {
    return [
    `/factories/${factoryId}/shift-patterns`
    ] as const;
    }

    
export const getFactoryShiftPatternsControllerListPatternsQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListPatternsQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>> = ({ signal }) => factoryShiftPatternsControllerListPatterns(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(factoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerListPatternsQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>>
export type FactoryShiftPatternsControllerListPatternsQueryError = void


export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift patterns for a factory
 */

export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List shift patterns for a factory
 */
export const prefetchFactoryShiftPatternsControllerListPatternsQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoryShiftPatternsControllerListPatternsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListPatternsQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>> = ({ signal }) => factoryShiftPatternsControllerListPatterns(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerListPatternsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>>
export type FactoryShiftPatternsControllerListPatternsSuspenseQueryError = void


export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift patterns for a factory
 */

export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a shift pattern with its slots and occurrences in one document. Every occurrence week_index must be < cycle_weeks. The date range must not overlap another active (unarchived) pattern of the factory.
 * @summary Create a shift pattern
 */
export type factoryShiftPatternsControllerCreatePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerCreatePatternResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerCreatePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerCreatePatternResponse409 = {
  data: void
  status: 409
}
    
export type factoryShiftPatternsControllerCreatePatternResponseSuccess = (factoryShiftPatternsControllerCreatePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerCreatePatternResponseError = (factoryShiftPatternsControllerCreatePatternResponse400 | factoryShiftPatternsControllerCreatePatternResponse404 | factoryShiftPatternsControllerCreatePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerCreatePatternResponse = (factoryShiftPatternsControllerCreatePatternResponseSuccess | factoryShiftPatternsControllerCreatePatternResponseError)

export const getFactoryShiftPatternsControllerCreatePatternUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/shift-patterns`
}

export const factoryShiftPatternsControllerCreatePattern = async (factoryId: string,
    createFactoryShiftPatternDto: CreateFactoryShiftPatternDto, options?: RequestInit): Promise<factoryShiftPatternsControllerCreatePatternResponse> => {
  
  return customFetch<factoryShiftPatternsControllerCreatePatternResponse>(getFactoryShiftPatternsControllerCreatePatternUrl(factoryId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFactoryShiftPatternDto,)
  }
);}




export const getFactoryShiftPatternsControllerCreatePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,{factoryId: string;data: CreateFactoryShiftPatternDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,{factoryId: string;data: CreateFactoryShiftPatternDto}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerCreatePattern'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, {factoryId: string;data: CreateFactoryShiftPatternDto}> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoryShiftPatternsControllerCreatePattern(factoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerCreatePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>>
    export type FactoryShiftPatternsControllerCreatePatternMutationBody = CreateFactoryShiftPatternDto
    export type FactoryShiftPatternsControllerCreatePatternMutationError = void

    /**
 * @summary Create a shift pattern
 */
export const useFactoryShiftPatternsControllerCreatePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,{factoryId: string;data: CreateFactoryShiftPatternDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>,
        TError,
        {factoryId: string;data: CreateFactoryShiftPatternDto},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerCreatePatternMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Partial update. When slots are provided they replace the existing slots wholesale: slots are matched by slot_name so a matching slot keeps its slot_id (display_order updated, occurrences replaced); names missing from the payload are deleted. Archived patterns cannot be edited (409).
 * @summary Update a shift pattern
 */
export type factoryShiftPatternsControllerUpdatePatternResponse200 = {
  data: FactoryShiftPatternDto
  status: 200
}

export type factoryShiftPatternsControllerUpdatePatternResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerUpdatePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUpdatePatternResponse409 = {
  data: void
  status: 409
}
    
export type factoryShiftPatternsControllerUpdatePatternResponseSuccess = (factoryShiftPatternsControllerUpdatePatternResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUpdatePatternResponseError = (factoryShiftPatternsControllerUpdatePatternResponse400 | factoryShiftPatternsControllerUpdatePatternResponse404 | factoryShiftPatternsControllerUpdatePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUpdatePatternResponse = (factoryShiftPatternsControllerUpdatePatternResponseSuccess | factoryShiftPatternsControllerUpdatePatternResponseError)

export const getFactoryShiftPatternsControllerUpdatePatternUrl = (factoryId: string,
    patternId: string,) => {


  

  return `/factories/${factoryId}/shift-patterns/${patternId}`
}

export const factoryShiftPatternsControllerUpdatePattern = async (factoryId: string,
    patternId: string,
    updateFactoryShiftPatternDto: UpdateFactoryShiftPatternDto, options?: RequestInit): Promise<factoryShiftPatternsControllerUpdatePatternResponse> => {
  
  return customFetch<factoryShiftPatternsControllerUpdatePatternResponse>(getFactoryShiftPatternsControllerUpdatePatternUrl(factoryId,patternId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateFactoryShiftPatternDto,)
  }
);}




export const getFactoryShiftPatternsControllerUpdatePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,{factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,{factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerUpdatePattern'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, {factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto}> = (props) => {
          const {factoryId,patternId,data} = props ?? {};

          return  factoryShiftPatternsControllerUpdatePattern(factoryId,patternId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUpdatePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>>
    export type FactoryShiftPatternsControllerUpdatePatternMutationBody = UpdateFactoryShiftPatternDto
    export type FactoryShiftPatternsControllerUpdatePatternMutationError = void

    /**
 * @summary Update a shift pattern
 */
export const useFactoryShiftPatternsControllerUpdatePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,{factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>,
        TError,
        {factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerUpdatePatternMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sets archived_at. Archived patterns drop out of the calendar and the non-overlap constraint, so a replacement pattern can be created over the same dates.
 * @summary Archive a shift pattern
 */
export type factoryShiftPatternsControllerArchivePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerArchivePatternResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerArchivePatternResponseSuccess = (factoryShiftPatternsControllerArchivePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerArchivePatternResponseError = (factoryShiftPatternsControllerArchivePatternResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerArchivePatternResponse = (factoryShiftPatternsControllerArchivePatternResponseSuccess | factoryShiftPatternsControllerArchivePatternResponseError)

export const getFactoryShiftPatternsControllerArchivePatternUrl = (factoryId: string,
    patternId: string,) => {


  

  return `/factories/${factoryId}/shift-patterns/${patternId}/archive`
}

export const factoryShiftPatternsControllerArchivePattern = async (factoryId: string,
    patternId: string, options?: RequestInit): Promise<factoryShiftPatternsControllerArchivePatternResponse> => {
  
  return customFetch<factoryShiftPatternsControllerArchivePatternResponse>(getFactoryShiftPatternsControllerArchivePatternUrl(factoryId,patternId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoryShiftPatternsControllerArchivePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,{factoryId: string;patternId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,{factoryId: string;patternId: string}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerArchivePattern'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, {factoryId: string;patternId: string}> = (props) => {
          const {factoryId,patternId} = props ?? {};

          return  factoryShiftPatternsControllerArchivePattern(factoryId,patternId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerArchivePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>>
    
    export type FactoryShiftPatternsControllerArchivePatternMutationError = void

    /**
 * @summary Archive a shift pattern
 */
export const useFactoryShiftPatternsControllerArchivePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,{factoryId: string;patternId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>,
        TError,
        {factoryId: string;patternId: string},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerArchivePatternMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Clears archived_at, re-entering the pattern into the non-overlap constraint — conflicts with another active pattern return 409.
 * @summary Unarchive a shift pattern
 */
export type factoryShiftPatternsControllerUnarchivePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerUnarchivePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUnarchivePatternResponse409 = {
  data: void
  status: 409
}
    
export type factoryShiftPatternsControllerUnarchivePatternResponseSuccess = (factoryShiftPatternsControllerUnarchivePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUnarchivePatternResponseError = (factoryShiftPatternsControllerUnarchivePatternResponse404 | factoryShiftPatternsControllerUnarchivePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUnarchivePatternResponse = (factoryShiftPatternsControllerUnarchivePatternResponseSuccess | factoryShiftPatternsControllerUnarchivePatternResponseError)

export const getFactoryShiftPatternsControllerUnarchivePatternUrl = (factoryId: string,
    patternId: string,) => {


  

  return `/factories/${factoryId}/shift-patterns/${patternId}/unarchive`
}

export const factoryShiftPatternsControllerUnarchivePattern = async (factoryId: string,
    patternId: string, options?: RequestInit): Promise<factoryShiftPatternsControllerUnarchivePatternResponse> => {
  
  return customFetch<factoryShiftPatternsControllerUnarchivePatternResponse>(getFactoryShiftPatternsControllerUnarchivePatternUrl(factoryId,patternId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoryShiftPatternsControllerUnarchivePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,{factoryId: string;patternId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,{factoryId: string;patternId: string}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerUnarchivePattern'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, {factoryId: string;patternId: string}> = (props) => {
          const {factoryId,patternId} = props ?? {};

          return  factoryShiftPatternsControllerUnarchivePattern(factoryId,patternId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUnarchivePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>>
    
    export type FactoryShiftPatternsControllerUnarchivePatternMutationError = void

    /**
 * @summary Unarchive a shift pattern
 */
export const useFactoryShiftPatternsControllerUnarchivePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,{factoryId: string;patternId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>,
        TError,
        {factoryId: string;patternId: string},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerUnarchivePatternMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns unarchived overrides, ordered by start_date. Pass from and to (both or neither) to keep only overrides intersecting that inclusive range.
 * @summary List shift overrides for a factory
 */
export type factoryShiftPatternsControllerListOverridesResponse200 = {
  data: FactoryShiftOverrideDto[]
  status: 200
}

export type factoryShiftPatternsControllerListOverridesResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerListOverridesResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerListOverridesResponseSuccess = (factoryShiftPatternsControllerListOverridesResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerListOverridesResponseError = (factoryShiftPatternsControllerListOverridesResponse400 | factoryShiftPatternsControllerListOverridesResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerListOverridesResponse = (factoryShiftPatternsControllerListOverridesResponseSuccess | factoryShiftPatternsControllerListOverridesResponseError)

export const getFactoryShiftPatternsControllerListOverridesUrl = (factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/shift-overrides?${stringifiedParams}` : `/factories/${factoryId}/shift-overrides`
}

export const factoryShiftPatternsControllerListOverrides = async (factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: RequestInit): Promise<factoryShiftPatternsControllerListOverridesResponse> => {
  
  return customFetch<factoryShiftPatternsControllerListOverridesResponse>(getFactoryShiftPatternsControllerListOverridesUrl(factoryId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoryShiftPatternsControllerListOverridesQueryKey = (factoryId?: string,
    params?: FactoryShiftPatternsControllerListOverridesParams,) => {
    return [
    `/factories/${factoryId}/shift-overrides`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFactoryShiftPatternsControllerListOverridesQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListOverridesQueryKey(factoryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>> = ({ signal }) => factoryShiftPatternsControllerListOverrides(factoryId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(factoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerListOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>>
export type FactoryShiftPatternsControllerListOverridesQueryError = void


export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params: undefined |  FactoryShiftPatternsControllerListOverridesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift overrides for a factory
 */

export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List shift overrides for a factory
 */
export const prefetchFactoryShiftPatternsControllerListOverridesQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoryShiftPatternsControllerListOverridesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListOverridesQueryKey(factoryId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>> = ({ signal }) => factoryShiftPatternsControllerListOverrides(factoryId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoryShiftPatternsControllerListOverridesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>>
export type FactoryShiftPatternsControllerListOverridesSuspenseQueryError = void


export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params: undefined |  FactoryShiftPatternsControllerListOverridesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List shift overrides for a factory
 */

export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Flags a date (or inclusive range) differently to the shift pattern: public_holiday (no hours), overtime (hours added; on an off day a slot-specific override synthesises a working day), or reduced_hours (hours replaced). end_date defaults to start_date. slot_id must belong to a shift pattern of this factory.
 * @summary Create a shift override
 */
export type factoryShiftPatternsControllerCreateOverrideResponse201 = {
  data: FactoryShiftOverrideDto
  status: 201
}

export type factoryShiftPatternsControllerCreateOverrideResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerCreateOverrideResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerCreateOverrideResponseSuccess = (factoryShiftPatternsControllerCreateOverrideResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerCreateOverrideResponseError = (factoryShiftPatternsControllerCreateOverrideResponse400 | factoryShiftPatternsControllerCreateOverrideResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerCreateOverrideResponse = (factoryShiftPatternsControllerCreateOverrideResponseSuccess | factoryShiftPatternsControllerCreateOverrideResponseError)

export const getFactoryShiftPatternsControllerCreateOverrideUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/shift-overrides`
}

export const factoryShiftPatternsControllerCreateOverride = async (factoryId: string,
    createShiftOverrideDto: CreateShiftOverrideDto, options?: RequestInit): Promise<factoryShiftPatternsControllerCreateOverrideResponse> => {
  
  return customFetch<factoryShiftPatternsControllerCreateOverrideResponse>(getFactoryShiftPatternsControllerCreateOverrideUrl(factoryId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createShiftOverrideDto,)
  }
);}




export const getFactoryShiftPatternsControllerCreateOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,{factoryId: string;data: CreateShiftOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,{factoryId: string;data: CreateShiftOverrideDto}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerCreateOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, {factoryId: string;data: CreateShiftOverrideDto}> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoryShiftPatternsControllerCreateOverride(factoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerCreateOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>>
    export type FactoryShiftPatternsControllerCreateOverrideMutationBody = CreateShiftOverrideDto
    export type FactoryShiftPatternsControllerCreateOverrideMutationError = void

    /**
 * @summary Create a shift override
 */
export const useFactoryShiftPatternsControllerCreateOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,{factoryId: string;data: CreateShiftOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>,
        TError,
        {factoryId: string;data: CreateShiftOverrideDto},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerCreateOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Partial update with the same validation as create (applied to the merged result). Archived overrides cannot be edited (409).
 * @summary Update a shift override
 */
export type factoryShiftPatternsControllerUpdateOverrideResponse200 = {
  data: FactoryShiftOverrideDto
  status: 200
}

export type factoryShiftPatternsControllerUpdateOverrideResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerUpdateOverrideResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUpdateOverrideResponse409 = {
  data: void
  status: 409
}
    
export type factoryShiftPatternsControllerUpdateOverrideResponseSuccess = (factoryShiftPatternsControllerUpdateOverrideResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUpdateOverrideResponseError = (factoryShiftPatternsControllerUpdateOverrideResponse400 | factoryShiftPatternsControllerUpdateOverrideResponse404 | factoryShiftPatternsControllerUpdateOverrideResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUpdateOverrideResponse = (factoryShiftPatternsControllerUpdateOverrideResponseSuccess | factoryShiftPatternsControllerUpdateOverrideResponseError)

export const getFactoryShiftPatternsControllerUpdateOverrideUrl = (factoryId: string,
    overrideId: string,) => {


  

  return `/factories/${factoryId}/shift-overrides/${overrideId}`
}

export const factoryShiftPatternsControllerUpdateOverride = async (factoryId: string,
    overrideId: string,
    updateShiftOverrideDto: UpdateShiftOverrideDto, options?: RequestInit): Promise<factoryShiftPatternsControllerUpdateOverrideResponse> => {
  
  return customFetch<factoryShiftPatternsControllerUpdateOverrideResponse>(getFactoryShiftPatternsControllerUpdateOverrideUrl(factoryId,overrideId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateShiftOverrideDto,)
  }
);}




export const getFactoryShiftPatternsControllerUpdateOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,{factoryId: string;overrideId: string;data: UpdateShiftOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,{factoryId: string;overrideId: string;data: UpdateShiftOverrideDto}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerUpdateOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, {factoryId: string;overrideId: string;data: UpdateShiftOverrideDto}> = (props) => {
          const {factoryId,overrideId,data} = props ?? {};

          return  factoryShiftPatternsControllerUpdateOverride(factoryId,overrideId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUpdateOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>>
    export type FactoryShiftPatternsControllerUpdateOverrideMutationBody = UpdateShiftOverrideDto
    export type FactoryShiftPatternsControllerUpdateOverrideMutationError = void

    /**
 * @summary Update a shift override
 */
export const useFactoryShiftPatternsControllerUpdateOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,{factoryId: string;overrideId: string;data: UpdateShiftOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>,
        TError,
        {factoryId: string;overrideId: string;data: UpdateShiftOverrideDto},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerUpdateOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sets archived_at; the override no longer affects the calendar.
 * @summary Archive a shift override
 */
export type factoryShiftPatternsControllerArchiveOverrideResponse201 = {
  data: FactoryShiftOverrideDto
  status: 201
}

export type factoryShiftPatternsControllerArchiveOverrideResponse404 = {
  data: void
  status: 404
}
    
export type factoryShiftPatternsControllerArchiveOverrideResponseSuccess = (factoryShiftPatternsControllerArchiveOverrideResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerArchiveOverrideResponseError = (factoryShiftPatternsControllerArchiveOverrideResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerArchiveOverrideResponse = (factoryShiftPatternsControllerArchiveOverrideResponseSuccess | factoryShiftPatternsControllerArchiveOverrideResponseError)

export const getFactoryShiftPatternsControllerArchiveOverrideUrl = (factoryId: string,
    overrideId: string,) => {


  

  return `/factories/${factoryId}/shift-overrides/${overrideId}/archive`
}

export const factoryShiftPatternsControllerArchiveOverride = async (factoryId: string,
    overrideId: string, options?: RequestInit): Promise<factoryShiftPatternsControllerArchiveOverrideResponse> => {
  
  return customFetch<factoryShiftPatternsControllerArchiveOverrideResponse>(getFactoryShiftPatternsControllerArchiveOverrideUrl(factoryId,overrideId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoryShiftPatternsControllerArchiveOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,{factoryId: string;overrideId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,{factoryId: string;overrideId: string}, TContext> => {

const mutationKey = ['factoryShiftPatternsControllerArchiveOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, {factoryId: string;overrideId: string}> = (props) => {
          const {factoryId,overrideId} = props ?? {};

          return  factoryShiftPatternsControllerArchiveOverride(factoryId,overrideId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerArchiveOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>>
    
    export type FactoryShiftPatternsControllerArchiveOverrideMutationError = void

    /**
 * @summary Archive a shift override
 */
export const useFactoryShiftPatternsControllerArchiveOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,{factoryId: string;overrideId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>,
        TError,
        {factoryId: string;overrideId: string},
        TContext
      > => {

      const mutationOptions = getFactoryShiftPatternsControllerArchiveOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    